// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAppNotificationDto } from './IAppNotificationDto';
import {
    IAppNotificationDtoFromJSON,
    IAppNotificationDtoFromJSONTyped,
    IAppNotificationDtoToJSON,
    IAppNotificationDtoToJSONTyped,
} from './IAppNotificationDto';

/**
 * 
 * @export
 * @interface IDismissedAppNotificationDto
 */
export interface IDismissedAppNotificationDto {
    /**
     * 
     * @type {Array<IAppNotificationDto>}
     * @memberof IDismissedAppNotificationDto
     */
    app_notifications?: Array<IAppNotificationDto>;
    /**
     * 
     * @type {number}
     * @memberof IDismissedAppNotificationDto
     */
    total_dismissed?: number;
    /**
     * 
     * @type {number}
     * @memberof IDismissedAppNotificationDto
     */
    total_dismissed_by_search?: number;
}

/**
 * Check if a given object implements the IDismissedAppNotificationDto interface.
 */
export function instanceOfIDismissedAppNotificationDto(value: object): value is IDismissedAppNotificationDto {
    return true;
}

export function IDismissedAppNotificationDtoFromJSON(json: any): IDismissedAppNotificationDto {
    return IDismissedAppNotificationDtoFromJSONTyped(json, false);
}

export function IDismissedAppNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDismissedAppNotificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'app_notifications': json['appNotifications'] == null ? undefined : ((json['appNotifications'] as Array<any>).map(IAppNotificationDtoFromJSON)),
        'total_dismissed': json['totalDismissed'] == null ? undefined : json['totalDismissed'],
        'total_dismissed_by_search': json['totalDismissedBySearch'] == null ? undefined : json['totalDismissedBySearch'],
    };
}

export function IDismissedAppNotificationDtoToJSON(json: any): IDismissedAppNotificationDto {
    return IDismissedAppNotificationDtoToJSONTyped(json, false);
}

export function IDismissedAppNotificationDtoToJSONTyped(value?: IDismissedAppNotificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appNotifications': value['app_notifications'] == null ? undefined : ((value['app_notifications'] as Array<any>).map(IAppNotificationDtoToJSON)),
        'totalDismissed': value['total_dismissed'],
        'totalDismissedBySearch': value['total_dismissed_by_search'],
    };
}

